export default __webpack_public_path__ + "static/media/logo3.df32e457.png";